"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var EventManagement_module_css_1 = __importDefault(require("./EventManagement.module.css"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var NewEventModal_1 = __importDefault(require("./NewEventModal"));
var react_admin_1 = require("react-admin");
var ra_data_simple_rest_1 = __importDefault(require("ra-data-simple-rest"));
var EventManagementList_1 = __importDefault(require("./EventManagementList"));
var RALayout_1 = __importDefault(require("@/Layouts/RALayout"));
var types_1 = require("@/Types/types");
var AccessControl_1 = __importDefault(require("../common/AccessControl"));
var EventManagementComponent = function (props) {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _a = (0, q_play_components_1.useModal)(), isShown = _a.isShown, toggle = _a.toggle;
    var _b = (0, react_1.useState)(null), existingEventData = _b[0], setExistingEventData = _b[1];
    var _c = (0, react_1.useState)("new"), modalMode = _c[0], setModalMode = _c[1];
    var resourceType = types_1.ResourceType.EVENT.toLowerCase() + "s";
    var openNewEventModal = function () {
        setModalMode("new");
        setExistingEventData(null);
        toggle();
    };
    var handleRowClick = function (eventData) {
        setModalMode("edit");
        setExistingEventData(eventData);
        toggle();
    };
    return (react_1.default.createElement("div", { className: EventManagement_module_css_1.default["content-container"] },
        react_1.default.createElement("div", { className: "d-flex flex-nowrap justify-content-end", style: { marginBottom: "5rem" } },
            react_1.default.createElement(AccessControl_1.default, { optionalPermissions: props.permissions.manage, resourceType: resourceType },
                react_1.default.createElement(q_play_components_1.Button, { text: t("New event"), onClick: openNewEventModal, dataCy: "newEventButton" }),
                react_1.default.createElement(NewEventModal_1.default, { isShown: isShown, toggle: toggle, modalMode: modalMode, existingEventData: existingEventData }))),
        react_1.default.createElement(react_admin_1.Admin, { dataProvider: (0, ra_data_simple_rest_1.default)("/api/list"), disableTelemetry: true, layout: RALayout_1.default },
            react_1.default.createElement(react_admin_1.Resource, { name: "events", list: function () { return react_1.default.createElement(EventManagementList_1.default, { permissions: props.permissions, resourceType: resourceType, onRowClick: handleRowClick }); } }))));
};
exports.default = EventManagementComponent;
